import type { WebImage, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

export const findById: FindById<'webImages'> = createFindById('webImages');
export const findByIdThrows: FindByIdThrows<'webImages'> = createFindByIdThrows('webImages');

type GetFulfilledWebImages = (state: YammerState) => Record<string, WebImage>;
export const getFulfilledWebImages: GetFulfilledWebImages = (state) => state.webImages.fulfilled.byId;
